// Generated by CoffeeScript 2.7.0
var BatchAssignmentsMixin;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default BatchAssignmentsMixin = {
  data: function() {
    return {
      requesting: false,
      action: 'approve',
      confirm: null,
      requesting: false,
      alertifyInstance: null,
      requestCount: 0
    };
  },
  methods: {
    approveEvent: function() {
      var assignment_data;
      if (this.requesting) {
        return;
      }
      this.action = 'approve';
      this.requestCount = 0;
      assignment_data = this.$refs.assignmentVm.getRequestData();
      if (!assignment_data) {
        return;
      }
      return _.map(this.assignments, (assignment) => {
        var data, entries;
        entries = this._generateEntries(assignment.response.entries, assignment_data.response_attributes.entries_attributes);
        data = {
          ...assignment_data,
          response_attributes: {
            entries_attributes: entries
          }
        };
        return this._doRequest(_.extend(data, {
          operation: 'route'
        }), assignment, this._afterRoute);
      });
    },
    transferEvent: function() {
      if (this.requesting) {
        return;
      }
      this.action = 'transfer';
      return this._openSettingModal();
    },
    _generateEntries: function(old_entries, updated_entries) {
      var entries, new_entries;
      // FIXME 优化 entries
      // 过滤旧值，保留 entry.id，返回新的 entry
      new_entries = _.filter(updated_entries, function(entry) {
        return !entry.id;
      });
      entries = _.map(old_entries, function(old_entry) {
        var entry;
        entry = _.find(new_entries, function(new_entry) {
          return old_entry.field_id === new_entry.field_id;
        });
        return _.extend(old_entry, entry, {
          id: old_entry.id
        });
      });
      return _.union(new_entries, entries);
    },
    _afterRequest: function() {
      this._requestAlertify(`${this.operations[this.action].name}成功`, 'success');
      return this._reload();
    },
    _settingEnabled: function(data) {
      if ((data.next_vertices.length === 1) && data.next_vertices[0].type === 'YetAnotherWorkflow::Vertex::Final') {
        return this._settingEnabledByCurrentVertexBaseJudgement();
      } else {
        return Boolean(this._settingEnabledByCurrentVertex() || this._settingEnabledByNextVertices(data));
      }
    },
    _settingEnabledByCurrentVertex: function() {
      if (this.action === 'approve') {
        if (this.currentVertex.dig('settings', 'assign_manually')) {
          return true;
        }
      }
      return this._settingEnabledByCurrentVertexBaseJudgement();
    },
    _settingEnabledByNextVertices: function(data) {
      var vertex;
      switch (data.next_vertices.length) {
        case 0:
          return false;
        case 1:
          vertex = data.next_vertices[0];
          return vertex.dig('settings', 'duration_threshold', 'enable_manual') || _.some(data.next_graphs, function(graph) {
            return graph.dig('settings', 'duration_threshold', 'enable_manual');
          });
        default:
          return true;
      }
    },
    _generateResquestUrl: function(assignment) {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(assignment.gid.toPath());
    },
    _requestAlertify: function(content, type) {
      if (this.alertifyInstance) {
        return;
      }
      return this.alertifyInstance = newAlertify(content, {
        type: type
      });
    },
    _formatGraphs: function(graphs) {
      return _.map(graphs, function(graph) {
        return new Skylark.Libs.HierarchicalTreeNode(graph);
      });
    },
    _parseErrors: function(error) {
      this.assignment.errors.merge(error);
      return this.assignment.errors.fullMessages().join('; ');
    },
    _reload: function() {
      return location.reload();
    },
    _clearErrors: function() {
      return this.assignment.errors.clear();
    }
  }
};
